import styled from "styled-components";

export const ScrollableContainer = styled.div`
    overflow-y: auto;
    max-height: ${({ $maxHeight }) => $maxHeight ?? "50dvh"};
`;

export default { ScrollableContainer };
